export function formatarMoeda(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function moedaParaNumero(valor) {
  if (typeof valor === "number") return valor;
  if (!valor) return 0;

  const limpo = String(valor)
    .replace(/\s/g, "")
    .replace("R$", "")
    .replace(/\./g, "")
    .replace(",", ".");

  const numero = Number(limpo);
  return Number.isNaN(numero) ? 0 : numero;
}

export function hojeISO() {
  return new Date().toLocaleDateString("en-CA");
}

export function mesAtualChave() {
  const data = new Date();
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  return `${ano}-${mes}`;
}
